import {useCommonItems} from "../../../../contexts/CommonItensProvider";
import {useAppContext} from "../../../../contexts/AppContext";
import dayjs from "dayjs";
import {useEffect, useMemo, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useQuery} from "@tanstack/react-query";
import {listaEmpresas} from "../../management/companies/configs/functions";
import {listaJustificativaRequisicao} from "../guidelines/config/functions";
import {getRetiradasOrigemExtra} from "./configs/functions";
import {checkPermissionsAndRedirect, getFormErrorMessage, verifyFieldsAreFilled} from "../../../../configs/functions";
import {exportRetiradasOrigemExtraToPDF, exportRetiradasToPDF} from "./configs/utils";
import {
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Grid,
    LinearProgress,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import LinkNavegacao from "../../../common/Link";
import {FilterAlt, Home as HomeIcon} from "@mui/icons-material";
import PageTitle from "../../../common/PageTitle";
import {ViewDetailsIcon} from "../../../common/Icons";
import {SelectEmpresaFilter} from "../../../common/SelectEmpresaFilter";
import {TooltipSelectDisabled} from "../../../common/TooltipSelectDisabled";
import DateRangePicker from "../../../common/DateRangePicker";
import {grey} from "@mui/material/colors";
import {DataGrid, ptBR} from "@mui/x-data-grid";
import {CustomToolbarReports} from "../../../common/CustomToolbarReports";


export function RelatorioRetiradaOrigemExtra(factory, deps) {
    const { exibirAlerta, exibirDialog, handleCloseDialog } = useCommonItems();
    const { dadosUsuario, getEmpresaIdSession, setEmpresaIdSession } = useAppContext();

    const initialRetiradaDataInicio = dayjs().subtract(1, 'month');
    const initialRetiradaDataFim = dayjs();
    const initialExtraDataInicio = dayjs().subtract(1, 'month');
    const initialExtraDataFim = dayjs();;

    const [dateRetiradaRange, setDateRetiradaRange] = useState([initialRetiradaDataInicio, initialRetiradaDataFim]);
    const [dateExtraRange, setExtraRange] = useState([initialExtraDataInicio, initialExtraDataFim]);

    const [supplyMachine, setDataSupplyMachine] = useState([]);

    const [empresas, setEmpresas] = useState([]);
    const [justificativas, setJustificativas] = useState([]);

    const [selectedEmpresaId, setSelectedEmpresaId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(false);

    const {
        handleSubmit,
        setValue,
        getValues,
        clearErrors,
        reset,
        control,
        formState: { errors },
    } = useForm();

    const columns = useMemo(() => [
        { field: 'codigo', headerName: 'Código Retirada', minWidth: 150, valueGetter: (params) => params.row.codigoRetirada },
        { field: 'matriculaColaborador', headerName: 'Matrícula Colaborador', minWidth: 200, valueGetter: (params) => params.row.matriculaColaborador },
        { field: 'nomeColaborador', headerName: 'Nome Colaborador', minWidth: 200, valueGetter: (params) => params.row.nomeColaborador },
        { field: 'caProdutoReq', headerName: 'CA Produto', minWidth: 100, valueGetter: (params) => params.row.caProdutoReq },
        { field: 'nomeProdutoReq', headerName: 'Nome Produto Solicitado', minWidth: 250, valueGetter: (params) => params.row.nomeProdutoReq },
        { field: 'codExternoProdutoRet', headerName: 'Cód. Produto Retirado', minWidth: 150, valueGetter: (params) => params.row.codExternoProdutoRet },
        { field: 'nomeProdutoRet', headerName: 'Nome Produto Retirado', minWidth: 200, valueGetter: (params) => params.row.nomeProdutoRet },
        { field: 'nomeEquipamentoReq', headerName: 'Equipamento Solicitação', minWidth: 200, valueGetter: (params) => params.row.nomeEquipamentoReq },
        { field: 'dataRequisicao', headerName: 'Data Solicitação', minWidth: 150, valueGetter: (params) => params.row.dataRequisicao },
        { field: 'nomeEquipamentoRet', headerName: 'Equipamento Retirada', minWidth: 200, valueGetter: (params) => params.row.nomeEquipamentoRet },
        { field: 'dataRetirada', headerName: 'Data Retirada', minWidth: 150, valueGetter: (params) => params.row.dataRetirada },
        { field: 'matriculaRespAprov', headerName: 'Matrícula Resp. Aprovação', minWidth: 200, valueGetter: (params) => params.row.matriculaRespAprov },
        { field: 'nomeRespAprov', headerName: 'Nome Resp. Aprovação', minWidth: 200, valueGetter: (params) => params.row.nomeRespAprov },
        { field: 'nomeJustificativa', headerName: 'Justificativa', minWidth: 200, valueGetter: (params) => params.row.nomeJustificativa },
        { field: 'matriculaRespEnt', headerName: 'Matrícula Resp. Entrega', minWidth: 200, valueGetter: (params) => params.row.matriculaRespEnt },
        { field: 'nomeRespEnt', headerName: 'Nome Resp. Entrega', minWidth: 250, valueGetter: (params) => params.row.nomeRespEnt },
        { field: 'quantidade', headerName: 'Quantidade', minWidth: 50, valueGetter: (params) => params.row.quantidade },
    ]);


    const { data: empresasData, error: listaEmpresasError, isLoading: isLoadingEmpresasData, isPending } = useQuery({
        queryKey: ['listaEmpresas'],
        queryFn: async () => {
            const response = await listaEmpresas(null, null, null, true);
            const empresasData = response?.data.data;

            let defaultEmpresaId = null;
            const selectedEmpresaIdSession = getEmpresaIdSession();

            if (selectedEmpresaIdSession) {
                defaultEmpresaId = selectedEmpresaIdSession;
            } else {
                defaultEmpresaId = empresasData[0].id;
                setEmpresaIdSession(empresasData[0].id);
            }

            setSelectedEmpresaId(defaultEmpresaId);

            const defaultValues = {
                id_empresas: [defaultEmpresaId],
                id_justificativa_requisicao: '',
                data_inicio_retirada: initialRetiradaDataInicio,
                data_fim_retirada: initialRetiradaDataFim,
                data_inicio_extra: initialExtraDataInicio,
                data_fim_extra: initialExtraDataFim,
            };

            reset(defaultValues);

            return response;
        },
        refetchOnWindowFocus: false,
    });

    const carregaJustificativas = async (empresaId) => {
        exibirDialog('Carregando justificativas');

        try {
            const filterAll = {
                id_empresas: Array.isArray(empresaId) ? empresaId : [empresaId],
                isFilter: true
            };
            const res = await listaJustificativaRequisicao(filterAll);

            setJustificativas(res.data.data);
        } catch (error) {
            exibirAlerta('Erro', 'Erro ao carregar justificativas', 'error');
        } finally {
            handleCloseDialog();
        }
    }

    async function loadReportData(id_empresa, id_justificativa_requisicao, data_inicio_retirada, data_fim_retirada, data_inicio_extra, data_fim_extra) {
        if (!id_empresa) return;

        try {
            setIsLoading(true);

            data_inicio_retirada = dayjs(data_inicio_retirada).format('YYYY-MM-DD');
            data_fim_retirada = dayjs(data_fim_retirada).format('YYYY-MM-DD');
            data_inicio_extra = dayjs(data_inicio_extra).format('YYYY-MM-DD');
            data_fim_extra = dayjs(data_fim_extra).format('YYYY-MM-DD');

            const filter = {
                data_inicio_retirada,
                data_fim_retirada,
                data_inicio_extra,
                data_fim_extra,
            };

            if (id_empresa === 'all') {
                filter.empresa = 1
            } else {
                filter.id_empresas = [id_empresa]
            }

            if (id_justificativa_requisicao) filter.id_justificativa_requisicao = id_justificativa_requisicao;

            const res = await getRetiradasOrigemExtra(filter);

            setDataSupplyMachine(res.data.retiradas);
        } catch (error) {
            exibirAlerta('Ops', 'Ocorreu um erro ao carregar dados do relatório.', 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const onSubmit = async (data) => {
        try {
            setIsSearched(true);
            loadReportData(data.id_empresas, data.id_justificativa_requisicao, data.data_inicio_retirada, data.data_fim_retirada, data.data_inicio_extra, data.data_fim_extra);
        } catch (error) {
            exibirAlerta('Erro', 'Erro ao carregar dados do relatório', 'error');
            setIsSearched(false);
        }
    };

    function getDataEmpresa(empresaId) {
        carregaJustificativas(empresaId);
    }

    useEffect(() => {
        if (empresasData) setEmpresas(empresasData?.data?.data || []);
    }, [empresasData]);

    const isLoadingEmpresas = isLoadingEmpresasData || isPending;

    useEffect(() => {
        const requiredPermissionsView = ["admin", "admin_relatorio"];
        checkPermissionsAndRedirect(requiredPermissionsView);

        return () => {
            reset();
        }
    }, []);

    useEffect(() => {
        if (selectedEmpresaId) {
            getDataEmpresa(selectedEmpresaId);
        }
    }, [selectedEmpresaId]);

    useEffect(() => {
        const id_empresas = selectedEmpresaId;
        const id_justificativa_requisicao = getValues('id_justificativa_requisicao');
        const data_inicio_retirada = getValues('data_inicio_retirada');
        const data_fim_retirada = getValues('data_fim_retirada');
        const data_inicio_extra = getValues('data_inicio_extra');
        const data_fim_extra = getValues('data_fim_extra');

        if (!id_empresas || !data_inicio_retirada || !data_fim_retirada) {
            return;
        }

        loadReportData(id_empresas, id_justificativa_requisicao, data_inicio_retirada, data_fim_retirada, data_inicio_extra, data_fim_extra);
    }, []);

    useEffect(() => {
        if (listaEmpresasError) {
            exibirAlerta('Erro', 'Erro ao carregar empresas', 'error');
        }
    }, [exibirAlerta, listaEmpresasError]);

    function exportThisToPDF(visibleColumns, reportName) {
        if (!getValues('id_empresas')) {
            return exibirAlerta('Ops', 'Selecione ao menos empresa', 'warning');
        }

        const data_inicio_retirada = getValues('data_inicio_retirada');
        const data_fim_retirada = getValues('data_fim_retirada');

        if (!data_inicio_retirada || !data_fim_retirada) {
            return exibirAlerta('Ops', 'Selecione um período para exportar', 'warning');
        }

        try {
            exportRetiradasOrigemExtraToPDF({
                tableData: supplyMachine,
                visibleColumns,
                reportName,
                dataInicio: dayjs(data_inicio_retirada).format('DD/MM/YYYY'),
                dataFim: dayjs(data_fim_retirada).format('DD/MM/YYYY'),
                selectEmpresa: empresas.find(empresa => empresa.id === selectedEmpresaId),
                dadosUsuario
            });

            exibirAlerta('Relatório gerado com sucesso!', '', 'success');
        } catch (error) {
            exibirAlerta('Erro', 'Ocorreu um erro ao exportar dados para PDF', 'error');
        }
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}
        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao>
                    <LinkNavegacao to='/epis'>Gestão de EPI's</LinkNavegacao>
                    <LinkNavegacao to='/epis/relatorios'>Relatórios</LinkNavegacao>
                    <Typography variant='span'>Relatório de Retiradas com Origem em Extras</Typography>
                </Breadcrumbs>
                <PageTitle icon={<ViewDetailsIcon fontSize='large' />} title="Relatório de Retiradas com Origem em Extras" />
            </Grid>

            <Grid container item xs={12} spacing={3} component="form" onSubmit={handleSubmit(onSubmit)}>
                <Grid container item xs={12} md={12} spacing={3} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Grid item xs={12} md={4} lg={3}>
                        <SelectEmpresaFilter
                            empresas={empresas}
                            id_empresas={empresas}
                            defaultValue={selectedEmpresaId}
                            onChangeValue={(value) => {
                                setIsSearched(false);
                                setSelectedEmpresaId(value);
                                setEmpresaIdSession(value);
                                setValue('id_empresas', value, { shouldDirty: true });
                                setValue('id_justificativa_requisicao', '', { shouldDirty: true });
                            }}
                            textHelper={false}
                            isLoading={isLoadingEmpresas}
                        />
                    </Grid>

                    <Grid item xs={12} md={4} lg={3}>
                        <TooltipSelectDisabled isDisabled={selectedEmpresaId}>
                            <Controller
                                name='id_justificativa_requisicao'
                                control={control}
                                rules={{ required: false }}
                                defaultValue={''}
                                render={({ field: { ref, onChange, ...field } }) => (
                                    <TextField
                                        {...field}
                                        select
                                        fullWidth
                                        label="Justificativa"
                                        disabled={!selectedEmpresaId}
                                        onChange={(e) => {
                                            setIsSearched(false);
                                            setValue('id_justificativa_requisicao', e.target.value, { shouldDirty: true })
                                            if (e.target.value) {
                                                clearErrors("id_justificativa_requisicao");
                                            }
                                        }}
                                        error={!!errors.id_justificativa_requisicao}
                                        helperText={getFormErrorMessage(errors, 'id_justificativa_requisicao')}
                                        size='small'
                                        InputProps={{ style: { backgroundColor: '#fff' } }}
                                    >
                                        <MenuItem>Todas</MenuItem>

                                        {justificativas.length > 0 ? (
                                            [
                                                justificativas.filter(option => option.status !== 0).map(option => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.nome ?? ''}
                                                    </MenuItem>
                                                )),
                                                justificativas.filter(option => option.status === 0).map(option => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.nome ?? ''} - (Inativo)
                                                    </MenuItem>
                                                ))
                                            ]
                                        ) : (
                                            <MenuItem disabled>Nenhuma disponível</MenuItem>
                                        )}
                                    </TextField>
                                )}
                            />
                        </TooltipSelectDisabled>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                            Data da Retirada
                        </Typography>

                        <DateRangePicker
                            value={dateRetiradaRange}
                            bgColor='#fff'
                            onChange={(value) => {
                                setDateRetiradaRange(value);
                                const [start, end] = value;
                                setValue('data_inicio_retirada', start ? dayjs(start).format('YYYY-MM-DD') : '');
                                setValue('data_fim_retirada', end ? dayjs(end).format('YYYY-MM-DD') : '');
                                setIsSearched(false);
                            }}
                            onReset={() => {
                                setDateRetiradaRange([null, null]);
                                setValue('data_inicio_retirada', '');
                                setValue('data_fim_retirada', '');
                                setIsSearched(false);
                            }}
                            hasError={errors.data_inicio_retirada || errors.data_fim_retirada}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                            Data da Solicitação
                        </Typography>

                        <DateRangePicker
                            value={dateExtraRange}
                            bgColor='#fff'
                            onChange={(value) => {
                                setExtraRange(value);
                                const [start, end] = value;
                                setValue('data_inicio_extra', start ? dayjs(start).format('YYYY-MM-DD') : '');
                                setValue('data_fim_extra', end ? dayjs(end).format('YYYY-MM-DD') : '');
                                setIsSearched(false);
                            }}
                            onReset={() => {
                                setExtraRange([null, null]);
                                setValue('data_inicio_extra', '');
                                setValue('data_fim_extra', '');
                                setIsSearched(false);
                            }}
                            hasError={errors.data_inicio_extra || errors.data_fim_extra}
                        />
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Button
                            type='submit'
                            color='primary'
                            variant='contained'
                            disabled={
                                isLoading ||
                                Object.keys(errors).length > 0 ||
                                !verifyFieldsAreFilled([getValues('id_empresas'), getValues('data_inicio_retirada'), getValues('data_fim_retirada')])
                            }
                            startIcon={isLoading ? <CircularProgress size={16} sx={{ color: "textSecondary" }} /> : <FilterAlt />}
                        >
                            Filtrar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{
                    height: supplyMachine.length > 0 ? "auto" : 400,
                    minHeight: 400,
                    width: '100%',
                    overflowX: "auto",
                    '& .MuiDataGrid-columnHeaders, .MuiDataGrid-toolbarContainer': {
                        backgroundColor: '#d8d8d8',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderRadius: 0
                    },
                }}>
                    <DataGrid
                        getRowId={(row) => row.idRetirada}
                        rows={supplyMachine.filter(row => row.quantidade > 0)}
                        columns={columns.map(col => {
                            const { renderCell, ...rest } = col;
                            if (col.field === 'action') return col;
                            return rest;
                        })}
                        loading={isLoading}
                        pageSizeOptions={[10, 20, 50, 100]}
                        // rowCount={numTotalItems}
                        paginationMode="client"
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 20, page: 0 },
                            },
                            columns: {
                                columnVisibilityModel: {
                                    // nomeSetor: false,
                                    id: false
                                },
                            },
                        }}
                        sx={{
                            backgroundColor: '#fff',
                            '.MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold !important',
                                overflow: 'visible !important',
                            },
                            '& .MuiDataGrid-virtualScroller': {
                                overflowX: 'auto !important',
                            },
                            // '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                            //   height: numTotalItems ? '8px' : 0,
                            // },
                            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
                                backgroundColor: grey[600],
                                borderRadius: '10px',
                            },
                            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: grey[700],
                            }
                        }}
                        disableRowSelectionOnClick
                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                        slots={{
                            toolbar: (props) =>
                                <CustomToolbarReports
                                    reportName="relatorio_retiradas_origem_extra"
                                    pdfExport={exportThisToPDF}
                                    props={props}
                                />
                            ,
                            loadingOverlay: LinearProgress,
                            noRowsOverlay: () => (
                                <Box style={{ display: "flex", width: '100%', textAlign: 'center', height: "100%", alignItems: 'center', justifyContent: 'center' }}>
                                    {isSearched ?
                                        <Typography variant='h6' color='textSecondary'>Nenhum registro encontrado para o filtro selecionado</Typography>
                                        :
                                        <Typography variant='h6' color='textSecondary'>Selecione uma empresa e o período que deseja filtrar</Typography>
                                    }
                                </Box>
                            )
                        }}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}